module.exports = __webpack_public_path__ + "img/icon-pronto-pago.8fa98075.svg";